export default __webpack_public_path__ + "d62c122da2560eb74b42552425595ba9.woff";